import { filterResponse, serverFetch } from '../api'
import type { Settings } from '../types/settings'

export const getSettings = (): Promise<Settings | null> => {
  return serverFetch<Settings>('/settings').then(filterResponse)
}
